import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: String,
    sidebarId: String,
    sidebarController: String
  }

  connect() {
    if (!this.hasUrlValue) {
      console.warn('sidebar-button controller requires url value')
    }
    if (!this.hasSidebarIdValue) {
      console.warn('sidebar-button controller requires sidebarId value')
    }
    if (!this.hasSidebarControllerValue) {
      console.warn('sidebar-button controller requires sidebarController value')
    }
  }

  toggle(event) {
    event.preventDefault()

    const sidebarElement = document.getElementById(this.sidebarIdValue)

    if (!sidebarElement) {
      console.error(`Sidebar element with id "${this.sidebarIdValue}" not found`)
      return
    }

    const sidebarController = this.application.getControllerForElementAndIdentifier(
      sidebarElement,
      this.sidebarControllerValue
    )

    if (!sidebarController) {
      console.error(`Could not get controller "${this.sidebarControllerValue}" for sidebar`)
      return
    }

    sidebarController.toggle(this.urlValue)
  }
}
